<template>
  <div class="nihao">
    <div class="msgSort">
      <el-tabs
        v-model="msgSort"
        :stretch="true"
        type="card"
        @tab-click="tabClick"
      >
        <el-tab-pane
          label="全部"
          name="all"
          :disabled="!idData.length || !isRequestSuccess"
        ></el-tab-pane>
        <el-tab-pane
          label="文件"
          name="file"
          :disabled="!idData.length || !isRequestSuccess"
        ></el-tab-pane>
        <el-tab-pane
          label="图片"
          name="image"
          :disabled="!idData.length || !isRequestSuccess"
        ></el-tab-pane>
        <el-tab-pane
          label="语音"
          name="call"
          :disabled="!idData.length || !isRequestSuccess"
        ></el-tab-pane>
      </el-tabs>
    </div>
    <div class="chat-common">
      <div class="chat-massage">
        <ChatContentScroll
          ref="ChatContentScrollRef"
          :idData="idData"
          :chatType="chatType"
          @requestSuccess="requestSuccess"
        >
        </ChatContentScroll>
      </div>
    </div>
  </div>
</template>
<script>
import ChatContentScroll from "@/components/chatLog/lib/chat-content-scroll.vue";
export default {
  name: "ChatType",
  // props: ["idData"],
  props: {
    // 员工 uid
    idData: {
      type: Array,
      default: [],
      required: true,
    },
    //聊天类型（区分公共组件调用不同类型）员工-employees 客户-员工：customer
    chatType: {
      type: String,
      default: "employees",
      required: true,
    },
  },
  components: { ChatContentScroll },
  data() {
    return {
      recordContent: [],
      recordContentNew: [],
      showMore: false,
      total: 0,
      current: 1,
      size: 10,
      sendFrom: "",
      sendTo: "",
      msgSort: "all",
      loading: false,
      showMorePosition: 0,
      disabled: false,
      isRequestSuccess: true,
      currentName: "all",
    };
  },

  methods: {
    clickMore() {
      this.size = this.size + 10;
    },
    setPosition(value) {
      this.showMorePosition = value;
    },
    resetParams() {
      this.recordContent = [];
      this.showMore = false;
      this.total = 0;
      this.current = 1;
      this.size = 10;
      this.showMorePosition = 0;
    },

    controlHeight() {
      this.$nextTick(function() {
        this.tableHeight =
          window.innerHeight - this.$refs.staffChatTable.$el.offsetTop - 237;

        // 监听窗口大小变化
        let self = this;
        window.onresize = function() {
          self.tableHeight =
            window.innerHeight - self.$refs.staffChatTable.$el.offsetTop - 237;
        };
      });
    },

    // 由子组件触发，请求完成触发，触发后在次通知父组件
    requestSuccess(val) {
      this.isRequestSuccess = val;
      this.$emit("requestSuccess", this.isRequestSuccess);
    },

    // 点击分类tab触发
    tabClick(val) {
      if (this.currentName !== this.msgSort) {
        this.$refs["ChatContentScrollRef"].typeChange(val.name);
        this.currentName = this.msgSort;
      }
    },
  },

  watch: {
    idData: {
      handler(newVal) {
        this.msgSort = "all";
        this.currentName = "all";
      },
    },
  },

  provide() {
    return {
      showMorePosition: () => this.showMorePosition,
      setPosition: this.setPosition,
    };
  },

  created() {
    console.log("dfsf", this.chatType);
  },
};
</script>
<style lang="scss" scoped>
.nihao {
  // width: 100%;
  // width: 31rem;
  height: 100%;
  display: flex;
  flex-direction: column;

  .msgSort {
    width: 100%;

    .el-tabs__header {
      margin: 0 !important;

      .el-tabs__item.is-active {
        border-bottom: none !important;
      }

      .el-tabs__nav {
        border: none !important;
      }

      .el-tabs__item {
        border-left: none;
        border-right: 1px solid #e4e7ed;
      }
    }
  }

  .chat-common {
    width: 100%;
    flex: 1;
    height: 100%;
    background: #f0f0f5;

    .chat-massage {
      width: 100%;
      height: 100%;
    }
  }
}

.vue-directive-image-previewer {
  z-index: 3000 !important;
}
</style>
